import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/dashboards',
      name: 'dashboards',
      component: () => import('@/views/dashboards.vue'),
      meta: {
        pageTitle: 'Dashboards',
        breadcrumb: [
          {
            text: 'Dashboards',
            active: true,
          },
        ],
      },
    },
    {
      path: '/smartIdData',
      name: 'smartIdData',
      component: () => import('@/views/smartIdData.vue'),
      meta: {
        pageTitle: 'Smart Id Data',
        breadcrumb: [
          {
            text: 'Smart Id Data',
            active: true,
          },
        ],
      },
    },
    {
      path: '/smartIdData/smartIdDataInfo/:id',
      name: 'smartIdDataInfo',
      component: () => import('@/views/smartIdDataInfo.vue'),
      meta: {
        navActiveLink: 'smartIdData',
        pageTitle: 'Smart Id Data Info',
        breadcrumb: [
          {
            text: 'Smart Id Data',
          },
          {
            text: 'Smart Id Data Info',
            active: true,
          },
        ],
      },
    },
    {
      path: '/smartIdData/smartIdDataInfo/smartIdDataCreate/:id',
      name: 'smartIdDataCreate',
      component: () => import('@/views/smartIdDataCreate.vue'),
      meta: {
        navActiveLink: 'smartIdData',
        pageTitle: 'Smart Id Data Info',
        breadcrumb: [
          {
            text: 'Smart Id Data',
          },
          {
            text: 'Smart Id Data Info',
          },
          {
            text: 'smartId Data Create',
            active: true,
          },
        ],
      },
    },
    {
      path: '/',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
